import { selectNotes } from '@features/workspace/store/selectors';
import { useAppSelector } from '@store/hooks';
import React from 'react';
import NoRecordsPlaceholder from '@features/workspace/components/no-records-placeholder';

const Notes: React.FC<any> = () => {
  const notes = useAppSelector(selectNotes);

  if (!notes?.length) {
    return (
      <NoRecordsPlaceholder
        text="Add a note relating to the customer to help all agents understand the latest interaction with the customer."
        title="There are currently no notes"
      />
    );
  }

  return <></>;
};

export default Notes;
